enum WorkerSkillStatus {
    Pending = 10,
    Verified = 90

}

export default WorkerSkillStatus;